import compact from "lodash/compact"
import fromPairs from "lodash/fromPairs"
import map from "lodash/map"

/**
 * Simple lens-y accessor for errors, so that child components don't need to
 * know the whole path of each error.
 */
export default class ErrorReader {
  constructor(errorsByParameter, prefix = "") {
    // Filter out errors that don't match the given prefix, then remove the
    // prefix from the remaining keys.
    this.all = fromPairs(
      compact(
        map(errorsByParameter, (value, key) => {
          if (key.indexOf(prefix) === 0) {
            return [key.slice(prefix.length), value]
          }
        })
      )
    )
  }

  select(newPrefix) {
    return new ErrorReader(this.all, newPrefix)
  }

  get(name) {
    return this.getAll(name).join("\n")
  }

  getAll(name) {
    return this.all[name] || []
  }
}
